import { render, staticRenderFns } from "./StatPlatforms.vue?vue&type=template&id=8c44691e&lang=pug&"
import script from "./StatPlatforms.vue?vue&type=script&lang=js&"
export * from "./StatPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports